import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { callAttemptItemDataSource } from 'infrastructure/data-sources/call-attempts';

import type { ICallAttemptItem } from 'infrastructure/data-sources/call-attempts';
import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';

type Options = IBaseSelectBoxOption<ICallAttemptItem['id'], ICallAttemptItem>[];

interface ICallAttemptSelectBoxProps
  extends Omit<IBaseSelectBoxProps, 'options'> {
  withAll?: boolean;
}

const CallAttemptSelectBox: React.FC<ICallAttemptSelectBoxProps> = ({
  withAll,
  ...props
}) => {
  const dataSource = useMemo(
    () => callAttemptItemDataSource(withAll),
    [withAll],
  );

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default CallAttemptSelectBox;
